<template>
  <FormRulesProvider :module-name="$constants.REQUEST">
    <FlotoFixedView>
      <MRow class="h-100">
        <MCol :size="12" class="flex flex-col h-100">
          <MRow :gutter="0" class="px-4">
            <MCol :sm="8" :size="12">
              <FlotoPageHeader
                :back-link="backRoute"
                :title="`${$t('create')} ${$tc('incident')}`"
                use-divider
              >
                <template v-slot:after-title>
                  <div class="inline-flex justify-end">
                    <MButton
                      id="create-btn"
                      class="mx-1"
                      :loading="creatingRequest"
                      type="submit"
                      @click="submitForm"
                    >
                      {{ $t('create') }}
                    </MButton>
                    <FlotoLink
                      id="cancel-btn"
                      :to="backRoute"
                      variant="default"
                      as-button
                    >
                      {{ $t('cancel') }}
                    </FlotoLink>
                  </div>
                </template>
              </FlotoPageHeader>
            </MCol>
            <MCol
              v-if="
                showRelatedKnowledge &&
                Object.keys(relatedKnowledgeSearchText).length
              "
              class="px-4 flex flex-col m-hide"
            >
              <h5 class="font-semibold mt-2">
                {{ $t('suggested_knowledge') }}
              </h5>
              <MDivider class="mt-4" />
            </MCol>
          </MRow>
          <FlotoScrollView>
            <MRow :gutter="0" class="px-4">
              <MCol :sm="8" :size="12">
                <SupportPortalTicketForm
                  ref="formRef"
                  :key="formConsumerKey"
                  :module-name="$route.params.ticketType"
                  with-submit
                  focus-event-brodcast
                  :use-transition-model="false"
                  :use-template="loggedIn"
                  @reset-form="handleResetForm"
                  @subject-blur="handleSubjectBlur"
                  @description-blur="handleDescriptionBlur"
                  @submit="handleFormSubmitted"
                  @templateSelected="handleTemplateSelected"
                  @startDate-update="handleStartDateUpdate"
                  @endDate-update="handleEndDateUpdate"
                />
              </MCol>
              <MCol
                v-if="
                  showRelatedKnowledge &&
                  Object.keys(relatedKnowledgeSearchText).length
                "
                :size="4"
                class="flex px-4 flex-col h-100 pb-2"
              >
                <RelatedKnowledge
                  :related-knowledge-search-text="relatedKnowledgeSearchText"
                />
              </MCol>
            </MRow>
          </FlotoScrollView>
        </MCol>
      </MRow>
    </FlotoFixedView>
  </FormRulesProvider>
</template>

<script>
import { successToast } from '@motadata/ui'
import RelatedKnowledge from '@modules/knowledge/components/related-knowledge'
import { FormActions } from '@state/modules/form'
import { authComputed } from '@state/modules/auth'
import { createApi } from '@modules/ticket/ticket-api'
import {
  SupportPortalConfigComputed,
  SupportPortalConfigMethods,
} from '@state/modules/support-portal-config'
import FormRulesProvider from '@components/providers/form-rules-provider/form-rules-provider'
import SupportPortalTicketForm from '../components/support-portal-ticket-form.vue'

export default {
  name: 'CreateIncident',
  components: {
    RelatedKnowledge,
    FormRulesProvider,
    SupportPortalTicketForm,
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      creatingRequest: false,
      relatedKnowledgeSearchText: {},
      formConsumerKey: 1,
    }
  },
  computed: {
    ...authComputed,
    ...SupportPortalConfigComputed,
    hasAssetModule() {
      return this.availableModulesInLicense.indexOf(this.$constants.ASSET) >= 0
    },
    backRoute() {
      if (this.loggedIn) {
        return this.$currentModule.getRoute('my-requests')
      }
      return this.$currentModule.getRoute()
    },
  },
  methods: {
    ...FormActions,
    ...SupportPortalConfigMethods,
    submitForm() {
      this.$refs.formRef.submit()
    },
    handleResetForm() {
      this.formConsumerKey++
    },
    handleFormSubmitted(data, captcha) {
      this.creatingRequest = true
      createApi(this.$constants.REQUEST, data, true, captcha)
        .then((data) => {
          if (this.loggedIn) {
            if (data.requesterId === (this.user || {}).id) {
              this.$router.push(
                this.$currentModule.getRoute('view-request', {
                  params: { id: data.id },
                })
              )
            } else {
              this.$router.push(this.$currentModule.getRoute('my-requests'))
            }
          } else {
            this.$router.push(this.$currentModule.getRoute())
            successToast(
              this.$t('created_successfully', {
                resource: `${this.$tc(this.$constants.REQUEST, 1)} (${
                  data.name
                })`,
              })
            )
          }
        })
        .catch(() => {
          this.$refs.formRef.handleRefreshCaptcha()
        })
        .finally(() => (this.creatingRequest = false))
    },
    handleSubjectBlur(event) {
      if (event.target.value && event.target.value.length > 1) {
        this.relatedKnowledgeSearchText = {
          ...this.relatedKnowledgeSearchText,
          subjectText: event.target.value,
        }
      }
    },
    handleDescriptionBlur(content) {
      this.relatedKnowledgeSearchText = {
        ...this.relatedKnowledgeSearchText,
        descriptionText: content,
      }
    },
    handleTemplateSelected(templateData) {
      this.relatedKnowledgeSearchText = {
        ...this.relatedKnowledgeSearchText,
        subjectText: templateData.subject || '',
        descriptionText: templateData.description || '',
      }
    },
    handleStartDateUpdate(change) {
      this.changeDates = {
        ...this.changeDates,
        ...change,
      }
    },
    handleEndDateUpdate(change) {
      this.changeDates = {
        ...this.changeDates,
        ...change,
      }
    },
  },
}
</script>
